// extracted by mini-css-extract-plugin
module.exports = {"container":"battery-level-chart_container_2yAfG","chartBox":"battery-level-chart_chartBox_38z60"};